import { render, staticRenderFns } from "./SearchBookings.vue?vue&type=template&id=3129d57c"
import script from "./SearchBookings.vue?vue&type=script&lang=js"
export * from "./SearchBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports